import {
  FETCH_COMPLIANCE_ASSESSMENTS,
  FETCH_COMPLIANCE_ASSESSMENTS_FAIL,
  FETCH_COMPLIANCE_ASSESSMENTS_SUCCESS,
  FETCH_COMPLIANCE_STANDARDS,
  FETCH_COMPLIANCE_STANDARDS_FAIL,
  FETCH_COMPLIANCE_STANDARDS_SUCCESS,
  PUT_COMPLIANCE_ASSESSMENT,
  PUT_COMPLIANCE_ASSESSMENT_FAIL,
  PUT_COMPLIANCE_ASSESSMENT_SUCCESS
} from "../constants/ActionTypes";

const INIT_STATE = {
  complianceStandards: null,
  loadingComplianceStandards: false,
  loadingComplianceStandardsFail: false,
  customerAssessments: null,
  loadingCustomerAssessments: false,
  loadingCustomerAssessmentsFail: false,
  complianceTogglesLoading: {},
  complianceTogglesFail: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    /***********************************
     * FETCH_COMPLIANCE_STANDARDS
     ***********************************/

    case FETCH_COMPLIANCE_STANDARDS: {
      return {
        ...state,
        loadingComplianceStandards: true,
        loadingComplianceStandardsFail: false
      }
    }

    case FETCH_COMPLIANCE_STANDARDS_SUCCESS: {
      return {
        ...state,
        complianceStandards: action.payload,
        loadingComplianceStandards: false,
        loadingComplianceStandardsFail: false
      }
    }

    case FETCH_COMPLIANCE_STANDARDS_FAIL: {
      return {
        ...state,
        loadingComplianceStandards: false,
        loadingComplianceStandardsFail: true
      }
    }

      /***********************************
       * FETCH_COMPLIANCE_ASSESSMENTS
       ***********************************/

    case FETCH_COMPLIANCE_ASSESSMENTS: {
      return {
        ...state,
        loadingCustomerAssessments: true,
        loadingCustomerAssessmentsFail: false
      }
    }

    case FETCH_COMPLIANCE_ASSESSMENTS_SUCCESS: {
      //if the assessments were null before this, initialize
      if (!state.customerAssessments) {
        return {
          ...state,
          customerAssessments: {
            // ...state.customerAssessments,
            [action.payload.customerId] : {
              // ...state.customerAssessments[action.payload.customerId],
              [action.payload.standardId]: action.payload.inboundData
            }
          },

          loadingCustomerAssessments: false,
          loadingCustomerAssessmentsFail: false
        }
      } else {
        return {
          ...state,
          customerAssessments: {
            ...state.customerAssessments,
            [action.payload.customerId] : {
              ...state.customerAssessments[action.payload.customerId],
              [action.payload.standardId]: action.payload.inboundData
            }
          },

          loadingCustomerAssessments: false,
          loadingCustomerAssessmentsFail: false
        }
      }
    }

    case FETCH_COMPLIANCE_ASSESSMENTS_FAIL: {
      return {
        ...state,
        loadingCustomerAssessments: false,
        loadingCustomerAssessmentsFail: true
      }
    }

      /***********************************
       * PUT_COMPLIANCE_ASSESSMENT
       ***********************************/

    case PUT_COMPLIANCE_ASSESSMENT: {
      return {
        ...state,
        complianceTogglesLoading: {
          ...state.complianceTogglesLoading,
          [action.payload.customerId] : {
            ...state.complianceTogglesLoading[action.payload.customerId],
            [action.payload.controlId] : true,
          }
        },
        complianceTogglesFail: {
          ...state.complianceTogglesFail,
          [action.payload.customerId] : {
            ...state.complianceTogglesFail[action.payload.customerId],
            [action.payload.controlId] : false,
          }
        },
      }
    }

    case PUT_COMPLIANCE_ASSESSMENT_SUCCESS: {
      //the function returns a single asessment
      // console.log("PUT_COMPLIANCE_ASSESSMENT_SUCCESS");
      try{
        const customerId = action.payload.customerId;
        const standardId = action.payload.standardId;
        const controlId = action.payload.controlId;
        const newAssessmentId = action.payload.assessmentId;
        // console.log("PUT_COMPLIANCE_ASSESSMENT_SUCCESS adding", action.payload.inboundData, "to ", customerId, standardId, controlId, newAssessmentId, "to state: ", state.customerAssessments )
        return {
          ...state,
          customerAssessments: {
            ...state.customerAssessments,
            [customerId]: {
              ...state.customerAssessments[customerId],
              [standardId]: {
                ...state.customerAssessments[customerId][standardId],
                [controlId] : {
                  ...state.customerAssessments[customerId][standardId][controlId],
                  [newAssessmentId] : action.payload.inboundData,
                }
              }
            }
          },

          complianceTogglesLoading: {
            ...state.complianceTogglesLoading,
            [customerId] : {
              ...state.complianceTogglesLoading[customerId],
              [controlId] : false,
            }
          },
          complianceTogglesFail: {
            ...state.complianceTogglesFail,
            [customerId] : {
              ...state.complianceTogglesFail[customerId],
              [controlId] : false,
            }
          },

        }
      } catch(e) {
        console.error("Error setting state from successful self assessment.", e);
        return {
          ...state,
          complianceTogglesLoading: {
            ...state.complianceTogglesLoading,
            [action.payload.customerId] : {
              ...state.complianceTogglesLoading[action.payload.customerId],
              [action.payload.controlId] : false,
            }
          },
          complianceTogglesFail: {
            ...state.complianceTogglesFail,
            [action.payload.customerId] : {
              ...state.complianceTogglesFail[action.payload.customerId],
              [action.payload.controlId] : true,
            }
          },
        }
      }

    }

    case PUT_COMPLIANCE_ASSESSMENT_FAIL: {
      return {
        ...state,
        complianceTogglesLoading: {
          ...state.complianceTogglesLoading,
          [action.payload.customerId] : {
            ...state.complianceTogglesLoading[action.payload.customerId],
            [action.payload.controlId] : false,
          }
        },
        complianceTogglesFail: {
          ...state.complianceTogglesFail,
          [action.payload.customerId] : {
            ...state.complianceTogglesFail[action.payload.customerId],
            [action.payload.controlId] : true,
          }
        },
      }
    }

    default:
      return state;
  }
}
